import PropTypes from "prop-types"
import classnames from "classnames"
import parse from "html-react-parser"
import icon from "images/web/browse/arrow-right.svg?raw"
import styles from "./applet_limit_warning.module.scss"
import { hasProPlusFeatures } from "shared/utils/tiers"

const AppletLimitWarning = ({ className, user: { tier, appletQuota }, onUpgrade }) => {
  const created = appletQuota.total - appletQuota.remaining
  const visible = !hasProPlusFeatures(tier) && appletQuota.remaining > 0

  if (!visible) return null

  if (className === "initial-step") {
    return (
      <div className={styles["applet-limit-bar"]}>
        <span>You&rsquo;re using {created} of {appletQuota.total} Applets.</span>
        <button type="button" onClick={onUpgrade}>
          Upgrade for more Applets
          {parse(icon)}
        </button>
      </div>
    )
  }

  return (
    <div className={classnames(styles["applet-limit-warning"], { [styles[className]]: !!className })}>
      You&rsquo;re using {created} of {appletQuota.total} Applets
    </div>
  )
}

AppletLimitWarning.propTypes = {
  user: PropTypes.shape({
    tier: PropTypes.string.isRequired,
    appletQuota: PropTypes.shape({
      total: PropTypes.number,
      remaining: PropTypes.number,
    }),
  }),
  className: PropTypes.string,
  onUpgrade: PropTypes.func,
}

export default AppletLimitWarning
